<template>
  <div class="container p-0">
    <nav class="navbar navbar-expand-md bg-primary">
      <ul class="navbar-nav ml-auto">
        <!-- <li class="nav-item mr-2">
          <a class="nav-link" href="#">
            <vs-input icon="search" placeholder="Search" v-model="search" />
          </a>
        </li> -->
        <li class="nav-item dropdown mr-3 mt-2">
          <vs-dropdown vs-custom-content vs-trigger-click>
            <a class="a-icon" href.prevent>
              <vs-chip color="warning">
                <i class="material-icons">notifications</i>
                <b>4 Notifications</b>
              </vs-chip>
            </a>

            <vs-dropdown-menu class="loginx" style="width:300px !important">
              <div class="dropdown-menu-header">
                <span class="badge badge-round badge-danger float-right mt-1">New 5</span>
                <h5>NOTIFICATIONS</h5>
              </div>

              <div class="list-group">
                <div data-role="container">
                  <div data-role="content">
                    <a href="javascript:void(0)" class="list-group-item p-2">
                      <div class="media">
                        <div class="pr-10">
                          <vs-avatar src="https://i.dawn.com/users/42.jpg?180907032818" />
                        </div>
                        <div class="media-body mt-2">
                          <h6 class="media-heading mb-0">A new order has been placed</h6>
                          <time
                            class="media-meta text-secondary"
                            datetime="2018-06-12T20:50:48+08:00"
                          >5 hours ago</time>
                        </div>
                      </div>
                    </a>
                    <a href="javascript:void(0)" class="list-group-item p-2" role="menuitem">
                      <div class="media">
                        <div class="pr-10">
                          <vs-avatar src="https://i.dawn.com/users/42.jpg?180907032818" />
                        </div>
                        <div class="media-body mt-2">
                          <h6 class="media-heading mb-0">Completed the task</h6>
                          <time
                            class="media-meta text-secondary"
                            datetime="2018-06-11T18:29:20+08:00"
                          >2 days ago</time>
                        </div>
                      </div>
                    </a>
                    <a href="javascript:void(0)" class="list-group-item p-2" role="menuitem">
                      <div class="media">
                        <div class="pr-10">
                          <vs-avatar src="https://i.dawn.com/users/42.jpg?180907032818" />
                        </div>
                        <div class="media-body mt-2">
                          <h6 class="media-heading mb-0">New Training has been Started</h6>
                          <time
                            class="media-meta text-secondary"
                            datetime="2018-06-11T14:05:00+08:00"
                          >2 days ago</time>
                        </div>
                      </div>
                    </a>
                    <a href="javascript:void(0)" class="list-group-item p-2" role="menuitem">
                      <div class="media">
                        <div class="pr-10">
                          <vs-avatar src="https://i.dawn.com/users/42.jpg?180907032818" />
                        </div>
                        <div class="media-body mt-2">
                          <h6 class="media-heading mb-0">New Training has been Started</h6>
                          <time
                            class="media-meta text-secondary"
                            datetime="2018-06-11T14:05:00+08:00"
                          >2 days ago</time>
                        </div>
                      </div>
                    </a>
                    <a href="javascript:void(0)" class="list-group-item p-2" role="menuitem">
                      <div class="media">
                        <div class="pr-10">
                          <vs-avatar src="https://i.dawn.com/users/42.jpg?180907032818" />
                        </div>
                        <div class="media-body mt-2">
                          <h6 class="media-heading mb-0">New Training has been Started</h6>
                          <time
                            class="media-meta text-secondary"
                            datetime="2018-06-11T14:05:00+08:00"
                          >2 days ago</time>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
        </li>
        <li class="nav-item dropdown mr-3 mt-1">
          <vs-dropdown vs-custom-content vs-trigger-click>
            <a class="a-icon" href.prevent>
              <h6 class="text-white mt-2">
                {{ currentUser }}
                <vs-icon class icon="expand_more"></vs-icon>
              </h6>
            </a>
            <vs-dropdown-menu class="loginx">
              <div class role="presentation"></div>
              <a class="dropdown-item" href="#" @click.prevent="logout" role="menuitem">Logout</a>
            </vs-dropdown-menu>
          </vs-dropdown>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
//import { bus } from "../../../main";
import axios from "axios";
export default {
  data: () => ({
    activeItem: 0,
    //search: "",
    currentUser: ""
  }),
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = !data;
    // });
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    if (localStorage.getItem("currentUser")) {
      var getName = JSON.parse(localStorage.getItem("currentUser"));
      this.currentUser = getName.name;
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    // isSidebar() {
    //   this.active = !this.active;
    //   bus.$emit("sidebarStatus", this.active);
    // }
    logout() {
      let self = this;
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/logout"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) localStorage.removeItem("token");
          localStorage.removeItem("currentUser");
          self.$router.push({ path: "/" });
        })
        .catch(error => {
          if (error) localStorage.removeItem("token");
          localStorage.removeItem("currentUser");
          self.$router.push({ path: "/" });
        });
    }
  }
};
</script>
<style>
.vs-input--placeholder {
  padding-top: 4px !important;
}
</style>

<style scoped>
.vs-input--placeholder {
  top: 0px !important;
}

.icon-scale {
  vertical-align: bottom;
}
.examplex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.examplex .a-icon {
  outline: none;
  text-decoration: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.examplex .a-icon i {
  font-size: 18px;
}
.icon-scale {
  color: #fff !important;
}
.vs-dropdown-menu .con-input {
  margin-bottom: 20px;
}
.loginx h3 {
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
}
.loginx p {
  max-width: 200px;
  font-size: 11px;
  padding: 5px;
}
.con-vs-dropdown--menu {
  width: 200px !important;
}

.bg-primary {
  /* height: 50px !important; */
  background: #06a6e0 !important;
}

@media (max-width: 768px) {
  .navbar-nav {
    flex-direction: initial !important;
  }
}
</style>
